import { render, staticRenderFns } from "./LotWishlistList.vue?vue&type=template&id=fba14194&"
import script from "./LotWishlistList.vue?vue&type=script&lang=js&"
export * from "./LotWishlistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports